"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _nuiIntl = require("@concur/nui-intl");

var _reactModal = _interopRequireDefault(require("react-modal"));

var _listingModule = require("./listingModule");

var _trackClick = require("../HOCs/trackClick");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  overlay: {
    zIndex: '100',
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  content: {
    position: 'initial',
    width: '600px',
    maxHeight: '80%',
    margin: '75px auto'
  }
};

var ConfirmationModal = function ConfirmationModal(_ref) {
  var isConfirmationModalOpen = _ref.isConfirmationModalOpen,
      modalNames = _ref.modalNames,
      toggle = _ref.toggle,
      options = _ref.options,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      listingData = _ref.listingData;

  var toggleThisModal = function toggleThisModal() {
    return toggle(modalNames.confirmation);
  };

  var listingName;

  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }

  var getModalHeader = function getModalHeader() {
    if (options.listingType === 'ACONCT') {
      return options.disconnectSuccess ? _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "UnenrollSuccessful"
      }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
        id: "UnenrollFail"
      });
    }

    return options.disconnectSuccess ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "DisconnectSuccessful"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "DisconnectFail"
    });
  };

  var getModalBody = function getModalBody() {
    return options.disconnectSuccess ? _react.default.createElement("div", {
      className: "row"
    }, _react.default.createElement("div", {
      className: "col-xs-1"
    }, _react.default.createElement("span", {
      className: "confirmation-icon icon-messaging-success icon-size-lg",
      style: {
        color: '#3A7827'
      }
    })), _react.default.createElement("div", {
      className: "col-xs-11",
      style: {
        paddingTop: '17px'
      }
    }, options.listingType === 'ACONCT' ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "UnenrollSuccessfulMessage"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "DisconnectSuccessfulMessage"
    }))) : _react.default.createElement("div", {
      className: "row"
    }, _react.default.createElement("div", {
      className: "col-xs-1"
    }, _react.default.createElement("span", {
      className: "confirmation-icon icon-messaging-error icon-size-lg",
      style: {
        color: '#CE202D'
      }
    })), _react.default.createElement("div", {
      className: "col-xs-11",
      style: {
        paddingTop: '17px'
      }
    }, options.listingType === 'ACONCT' ? _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "UnenrollFailMessage"
    }) : _react.default.createElement(_nuiIntl.FormattedMessage, {
      id: "DisconnectFailMessage"
    })));
  };

  _reactModal.default.setAppElement('#root');

  return _react.default.createElement("div", null, _react.default.createElement(_reactModal.default, {
    style: style,
    isOpen: isConfirmationModalOpen,
    onRequestClose: toggleThisModal,
    contentLabel: "Confirmation Modal"
  }, _react.default.createElement("div", {
    className: "row inside-modal"
  }, _react.default.createElement("div", {
    className: "col-xs-11"
  }, _react.default.createElement("h3", null, getModalHeader())), _react.default.createElement("div", {
    className: "col-xs-1"
  }, _react.default.createElement("span", {
    className: "close-tandc-modal pull-right",
    onClick: toggleThisModal
  }, "\xD7"))), _react.default.createElement("hr", null), getModalBody(), _react.default.createElement("hr", null), _react.default.createElement("div", {
    className: "row"
  }, _react.default.createElement("div", {
    className: "col-xs-12"
  }, _react.default.createElement(_trackClick.Tracked, {
    event: "CLICK",
    additional: {
      context: 'LISTING_DETAILS',
      type: 'BUTTON',
      value: 'DISCONNECT_CONF_MODAL_OK',
      v2_listing_id: listingId,
      app_name: listingName,
      domain: window.location.hostname
    }
  }, _react.default.createElement("button", {
    style: {
      width: '110px',
      marginLeft: '10px'
    },
    className: "btn btn-lg btn-default pull-right",
    onClick: toggleThisModal
  }, _react.default.createElement(_nuiIntl.FormattedMessage, {
    id: "Ok"
  })))))));
};

var mapStateToConfirmationProps = function mapStateToConfirmationProps(state) {
  return {
    isConfirmationModalOpen: state.listing.isConfirmationModalOpen,
    listingData: state.listing,
    modalNames: state.listing.modalNames,
    options: state.listing.modalOptions
  };
};

ConfirmationModal.propTypes = {
  isConfirmationModalOpen: _propTypes.default.bool.isRequired,
  modalNames: _propTypes.default.object.isRequired,
  options: _propTypes.default.object.isRequired,
  toggle: _propTypes.default.func.isRequired,
  listingId: _propTypes.default.string,
  v1ListingId: _propTypes.default.string,
  listingData: _propTypes.default.object
};

var _default = (0, _reactRedux.connect)(mapStateToConfirmationProps, {
  toggle: _listingModule.toggleModal
})(ConfirmationModal);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/ConfirmationModal.js
// module id = 272
// module chunks = 0